/**
 * Acceso a las features (capacidades) del usuario.
 *
 * El backend ya resuelve la suscripción y viaja en `user.features`: cada pack
 * del catálogo concede los grupos que tiene asignados (y con ellos todas sus
 * features), más las que se le activaron sueltas, y el grupo `base` siempre.
 * Las rutas que dependen de esto están tras `middleware('feature:código')`, que
 * usa exactamente esa lista para decidir entre dejar pasar o responder 403.
 *
 * Por eso no se pueden mirar los códigos de pack. El acceso a una feature
 * puede venir de un pack que no se llama igual: el pack interno `completo`
 * concede todos los grupos, un reseller puede tener un pack propio con el grupo
 * `contabilidad` enganchado, o la feature se activa suelta en `pack_features`.
 * En esos casos `packs` no contiene `contabilidad` pero la feature sí está
 * concedida, y el TPV la escondía sin motivo.
 */
export function hasFeature(user, code) {
  if (!user) return false;

  const packs = user.packs || [];

  // Sin packs el backend da acceso completo: los packs sirven para recortar el
  // acceso, no para darlo.
  if (packs.length === 0) return true;

  const features = user.features;

  // Backend que ya resuelve las features: es la fuente de verdad, y la misma
  // que aplica el middleware `feature:`.
  if (Array.isArray(features)) return features.includes(code);

  // Instalaciones antiguas sin `features`: se recurre a los códigos de pack,
  // que es como funcionaba antes de que existieran.
  return packs.some((pack) => pack.code === code);
}